var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentMethodActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 0.9375H3.5C1.9475 0.9375 0.6875 2.1975 0.6875 3.75V8.25C0.6875 9.8025 1.9475 11.0625 3.5 11.0625H12.5C14.0525 11.0625 15.3125 9.8025 15.3125 8.25V3.75C15.3125 2.1975 14.0525 0.9375 12.5 0.9375ZM3.5 2.0625H12.5C13.43 2.0625 14.1875 2.82 14.1875 3.75V3.9375H1.8125V3.75C1.8125 2.82 2.57 2.0625 3.5 2.0625ZM12.5 9.9375H3.5C2.57 9.9375 1.8125 9.18 1.8125 8.25V5.0625H14.1875V8.25C14.1875 9.18 13.43 9.9375 12.5 9.9375Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5 6.9375H10.25C9.9425 6.9375 9.6875 7.1925 9.6875 7.5C9.6875 7.8075 9.9425 8.0625 10.25 8.0625H12.5C12.8075 8.0625 13.0625 7.8075 13.0625 7.5C13.0625 7.1925 12.8075 6.9375 12.5 6.9375Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethodActivity);
export default __webpack_public_path__ + "static/media/payment-method-activity.04a1ab931d2aec6d1b8a5da03cb068cf.svg";
export { ForwardRef as ReactComponent };